import React, { useState, useEffect } from 'react';
import { tidyText } from '../../utils/tidyText';
import './quiz.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.cinebotz.com';

export function EndQuiz({ numCorrect, user, qsetid, qdata }) {
  const [stats, setStats] = useState(null);
  const percent = qdata?.length ? Math.round((100 * numCorrect) / qdata.length) : 0;
  const passed = percent >= 60;

  useEffect(() => {
    let cancelled = false;
    const body = {
      qsetid,
      userid: user,
      attempts: '1',
      score: qdata?.length ? ((100 * numCorrect) / qdata.length).toString() : '0',
      scorehealth: 'high',
    };
    fetch(`${API_BASE}/api/score`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
      .then(() => fetch(`${API_BASE}/stats/${user}`))
      .then((r) => r.json())
      .then((stats) => {
        if (!cancelled) setStats(stats);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [qsetid, user, numCorrect, qdata?.length]);

  return (
    <div className="quiz quiz--end">
      <div className="quiz-end">
        <section className="quiz-end-score">
          <h2 className="quiz-end-title">Your Score</h2>
          <p className={`quiz-end-result quiz-end-result--${passed ? 'pass' : 'fail'}`}>
            {passed
              ? <>Well done! You got <strong>{percent}%</strong>!</>
              : <>You got <strong>{percent}%</strong>. Better luck next time!</>}
          </p>
        </section>

        <section className="quiz-end-answers">
          <h2 className="quiz-end-answers-title">Correct Answers</h2>
          <ul className="quiz-end-list">
            {(qdata || []).map((q, i) => (
              <li key={i} className="quiz-end-item">
                <p className="quiz-end-question">{tidyText(q.question)}</p>
                <p className="quiz-end-answer">{tidyText(q.correctAnswer)}</p>
              </li>
            ))}
          </ul>
        </section>

        {stats && (
          <section className="quiz-end-stats">
            <h2 className="quiz-end-stats-title">Your CineBotz Statistics</h2>
            <dl className="quiz-end-stats-list">
              <div className="quiz-end-stat">
                <dt>Total quizzes taken</dt>
                <dd>{stats.quizzes ?? '—'}</dd>
              </div>
              <div className="quiz-end-stat">
                <dt>Average score</dt>
                <dd>{stats.average ?? '—'}</dd>
              </div>
              <div className="quiz-end-stat">
                <dt>Highest score</dt>
                <dd>{stats.highest ?? '—'}</dd>
              </div>
            </dl>
          </section>
        )}

        <p className="quiz-end-cta">Come again tomorrow for a new set of questions!</p>
      </div>
    </div>
  );
}

export default EndQuiz;
